import { render } from "./routerlogout.vue?vue&type=template&id=1ee9c85e"
import script from "./routerlogout.vue?vue&type=script&lang=js"
export * from "./routerlogout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__